import React from 'react'
import BannerImg from '../../Images/Banner 2 1.png'
import { useNavigate } from 'react-router-dom'
const BusinessDigitalBanner = () => {
  const navigate = useNavigate()
  return (
    <>
      <div className='business_card_banner_img_div'>

        <div className='business_card_banner_content'>
          <h5>Create free digital business cards revolutionising
            business networking in the modern age while protecting
            the environment.</h5>

          <h4>By switching to an digital business card,
            You can eliminate many paper cards
            and easily Manage your contacts' lifetime validity.</h4>
          <div >
            <button onClick={(() => { navigate('/free-digital-business-card') })}>Get started for free</button>
          </div>


        </div>
      </div>
    </>
  )
}

export default BusinessDigitalBanner